import styles from "./PriceListItem.module.scss";
import classNames from "classnames";
import React from "react";

const TIER_THEMES = {
    1: { className: "tierKveikja" },
    2: { className: "tierVaxa" },
    3: { className: "tierEfla" },
    4: { className: "tierDafna" },
};

function PriceListItem({
    title,
    price,
    price2,
    descriptionList,
    bottomCopy,
    className,
    cardItem,
    badge,
    highlighted,
    promoted,
    ctaLabel,
    ctaHref,
    ctaStyle,
}) {
    const theme = TIER_THEMES[cardItem] || TIER_THEMES[1];

    return (
        <div
            className={classNames(
                styles.card,
                styles[theme.className],
                { [styles.highlighted]: highlighted },
                { [styles.promoted]: promoted },
                className,
            )}
        >
            {badge && <div className={styles.badge}>{badge}</div>}

            <div className={styles.header}>
                <h2 className={styles.tierName}>{title}</h2>
                <p className={styles.tagline}>{bottomCopy}</p>
            </div>

            <div className={styles.priceBlock}>
                <div className={styles.priceLine}>
                    {price.startsWith("frá ") ? (
                        <>
                            <span className={styles.pricePrefix}>frá</span>
                            <span
                                className={classNames(
                                    styles.priceMain,
                                    styles.priceMainCompact,
                                )}
                            >
                                {price.slice(4)}
                            </span>
                        </>
                    ) : (
                        <span className={styles.priceMain}>{price}</span>
                    )}
                    <span className={styles.priceCurrency}>kr.</span>
                </div>
                <div className={styles.pricePeriod}>á mánuði</div>
                {price2 && (
                    <div className={styles.priceAlt}>
                        Eftir styrk: <strong>{price2} kr./mán.</strong>
                    </div>
                )}
            </div>

            <a
                href={ctaHref || "https://admin.laufid.is/registration"}
                className={classNames(
                    styles.cta,
                    { [styles.ctaPrimary]: ctaStyle === "primary" },
                    { [styles.ctaOutline]: ctaStyle === "outline" },
                    { [styles.ctaDark]: ctaStyle === "dark" },
                )}
            >
                {ctaLabel || "Byrja"}
            </a>

            <div className={styles.divider} />

            <ul className={styles.features}>
                {descriptionList.map((item, index) => (
                    <li
                        key={title + "_" + index}
                        className={classNames({
                            [styles.excluded]: !item.included,
                        })}
                    >
                        <span className={styles.featureIcon}>
                            {item.included ? "✓" : "–"}
                        </span>
                        <span className={styles.featureText}>{item.copy}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PriceListItem;
